import { render, staticRenderFns } from "./DenseTable.vue?vue&type=template&id=2cab36cf&"
import script from "./DenseTable.vue?vue&type=script&lang=js&"
export * from "./DenseTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports